"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPDATE_USER_AUTH = exports.CREATE_USER_AUTH = void 0;
const react_1 = __importStar(require("react"));
const schemaComponents_1 = require("@/schemaComponents");
const react_bootstrap_1 = require("react-bootstrap");
const models_hook_1 = require("app/models.hook");
const __1 = require("..");
const schema_1 = __importDefault(require("./schema"));
const preview_1 = require("./preview");
const auth_1 = require("common/auth");
const index_1 = require("../../../index");
exports.CREATE_USER_AUTH = __1.USER_AUTHS.sub("/new", UserAuth);
exports.UPDATE_USER_AUTH = __1.USER_AUTH.sub("", UserAuth);
function UserAuth({ email }) {
    (0, auth_1.useAdminPageAuthorization)();
    const [error, setError] = (0, react_1.useState)();
    const { data, isEditing, set, remove, loading } = (0, models_hook_1.useAuthEmailDoc)({ email });
    const parameter = {
        title: isEditing ? "システム詳細" : "システムユーザ新規作成",
        schema: (0, schema_1.default)({ isEditing }),
        edit: {
            handler: set,
        },
        remove: isEditing ? { handler: remove } : undefined,
        preview: {
            title: "ユーザ認証情報",
            component: preview_1.PreviewComponent,
        },
        backPath: (0, index_1.resolveRoute)("LIST_USER_AUTH"),
        header: {
            isStacked: true,
        },
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        error && react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger" }, error.message),
        react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: isEditing ? data : Object.assign(Object.assign({}, data), { role: "master" }), parameter: parameter, loading: !!(isEditing && loading), editModeEnabled: true })));
}
exports.default = UserAuth;
